module.exports = __webpack_public_path__ + "img/ile-de-france.962ebcd3.png";